module.exports = __webpack_public_path__ + "img/~sumseikr_40_60.b6614306.jpg";